import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconCasino(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-casino_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M11,12.51,5,15a3,3,0,0,0-1.79,3.84l7.82,22Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M47.07,15,41,12.51V40.79l7.82-21.95A3,3,0,0,0,47.07,15Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M36,8H16a3,3,0,0,0-3,3V41a3,3,0,0,0,3,3H36a3,3,0,0,0,3-3V11A3,3,0,0,0,36,8Zm1,33a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H36a1,1,0,0,1,1,1Z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 18,
        cy: 13,
        r: 1
      }), /*#__PURE__*/React.createElement("circle", {
        cx: 34,
        cy: 39,
        r: 1
      }), /*#__PURE__*/React.createElement("path", {
        d: "M28.48,20.06a4.47,4.47,0,0,0-2.47.73,4.55,4.55,0,0,0-7,3.44,6.42,6.42,0,0,0,.47,2.34c1.49,3.61,6,5.25,6.21,5.31a.92.92,0,0,0,.33.06,1,1,0,0,0,.33-.06c.19-.06,4.72-1.7,6.17-5.23A6,6,0,0,0,33,24.23,4.44,4.44,0,0,0,28.48,20.06Z"
      }));
    }
  }));
}
export default SvgIconCasino;